<template>
  <div v-wechat-title="title" style="height:100%">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
    name: `Organization`,
    props: {

    },
    data() {
        return {
            title: `组织架构`
        }
    },
    computed: {

    },
    created() {
        this.$store.dispatch(`ADD_HOSPITAL_WARD_AUTH`)
    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Organization/Index.vue